import React, { forwardRef } from 'react';
const Badge = forwardRef(function Badge({ testId = 'store-badge', children, ...otherProps }, ref) {
    return (React.createElement("div", Object.assign({ ref: ref, "data-store-badge": true, "data-testid": testId }, otherProps), children));
});
export default Badge;
//# sourceMappingURL=Badge.js.map